// eslint-disable-next-line import/no-unassigned-import
import "bootstrap";
// eslint-disable-next-line import/no-unassigned-import
import "reflect-metadata";
// eslint-disable-next-line import/no-unassigned-import
import "./styles/app.scss";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowLeft,
  faArrowRight,
  faChevronDown,
  faChevronRight,
  faCompass,
  faQuestionCircle,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BootstrapVue } from "bootstrap-vue";
import Vue from "vue";
import Component from "vue-class-component";
// eslint-disable-next-line import/no-unassigned-import
import vSelect from "vue-select";
// eslint-disable-next-line import/no-unassigned-import
import "vue-select/dist/vue-select.css";
import App from "./app.vue";
import router from "./router";
import store from "./store";
import { AuthService } from "@/services/auth";

async function start() {
    Vue.use(BootstrapVue);
    Vue.component("font-awesome-icon", FontAwesomeIcon);
    Vue.component("v-select", vSelect);
    Vue.config.productionTip = false;

    Component.registerHooks([
        "beforeRouteEnter",
        "beforeRouteLeave",
        "beforeRouteUpdate"
    ]);

    library.add(
        faArrowLeft,
        faArrowRight,
        faChevronDown,
        faChevronRight,
        faCompass,
        faQuestionCircle,
        faTimes
    );

    await AuthService.initialize();

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount("#app");
}

start();
